<template>

    <div>
        <button type="button" :class="buttonClass" v-html="buttonText" @click.prevent="toggleModal" :disabled="buttonDisabled"></button>

        <!-- Confirmation Modal -->
        <div class="fixed z-20 inset-0 overflow-y-auto" :aria-labelledby="id" role="dialog" aria-modal="true" v-show="show">
            <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                <!--
                  Background overlay, show/hide based on modal state.

                  Entering: "ease-out duration-300"
                    From: "opacity-0"
                    To: "opacity-100"
                  Leaving: "ease-in duration-200"
                    From: "opacity-100"
                    To: "opacity-0"
                -->
                <div class="fixed inset-0 bg-slate-500 bg-opacity-75 transition-opacity"></div>

                <!-- This element is to trick the browser into centering the modal contents. -->
                <span class="hidden sm:inline-block sm:align-middle sm:h-screen">&#8203;</span>

                <!--
                  Modal panel, show/hide based on modal state.

                  Entering: "ease-out duration-300"
                    From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    To: "opacity-100 translate-y-0 sm:scale-100"
                  Leaving: "ease-in duration-200"
                    From: "opacity-100 translate-y-0 sm:scale-100"
                    To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                -->
                <div class="relative inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
                    <div class="sm:flex sm:items-start">
                        <slot></slot>
                    </div>
                    <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                        <button type="submit" class="ml-2" @click.prevent="confirmAction">Confirm</button>
                        <button type="button" class="alt mr-2" @click.prevent="cancelAction">Cancel</button>
                    </div>
                </div>

            </div>
        </div>
    </div>


</template>

<script>
import {defineComponent} from "vue";

export default defineComponent({
    props: {
        id: {
            type: String,
            required: false,
            default: 'modal-title',
        },
        buttonClass: {
            type: String,
            required: false,
            default: 'btn',
        },
        buttonDisabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        buttonText: {
            type: String,
            required: false,
            default: 'Show Modal'
        }
    },
    data() {
        return {
            show: false
        }
    },
    methods: {
        toggleModal() {
            this.show = ! this.show;

            if (this.show === true) {
                this.$emit('openModal');
            } else {
                this.$emit('closeModal');
            }
        },
        confirmAction() {
            this.toggleModal();

            return this.$emit('confirmAction');
        },
        cancelAction() {
            this.toggleModal();

            return this.$emit('cancelAction');
        }
    }
});
</script>
